import { BasketSummary } from '../interfaces/Basket/BasketSummary';

export const getTotalBasketAmount = (basketSummary?: BasketSummary): number =>
  basketSummary?.items.reduce((acc, item) => acc + item.total.amount, 0) ?? 0;

export const getTotalBasketQuantity = (basketSummary?: BasketSummary): number =>
  basketSummary?.items.reduce((acc, item) => acc + item.quantity, 0) ?? 0;
